import { warnOnce } from '../../utils/warn-once.mjs';
import { useScroll } from '../use-scroll.mjs';

function useViewportScroll() {
    warnOnce(false, "useViewportScroll is deprecated. Convert to useScroll().");
    return useScroll();
}

export { useViewportScroll };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.mjs
// module id = 0/+z
// module chunks = 0